import api from "./api";

class FilesManager {

    files(config?: any) {
        return api.get(`/files`, config)
    }

    file(file_id:string | number) {
        return api.get(`/files/${file_id}`)
    }

    download(file_id:string|number) {
        return api.get(`/files/${file_id}/download`, {
            responseType: 'blob'
        })
    }

    filesCreate(data: any) {
        return api.post(`/files`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }

}

const filesManager = new FilesManager()

export default filesManager
